import React, { useState, useEffect, Suspense, Component } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layouts from "./Components/Common/layout/Layouts.js";
import "./App.css"
import { HospitalProvider } from "./Utils/Context/HospitalContext.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function App() {
  const Overview = React.lazy(() => import("./Components/pages/Dashboard/Dashboard.js"));
  const Login = React.lazy(() => import("./Components/pages/Auth/Login.js"));
  const SignUp = React.lazy(() => import("./Components/pages/Auth/Signup.js"));
  const Notification = React.lazy(() => import("./Components/pages/Notification/Notification.js"));
  const Chat = React.lazy(() => import("./Components/pages/chat/Chat.js"));
  const Teams = React.lazy(() => import("./Components/pages/Teams/Ourteams.js"));
  const Version = React.lazy(() => import("./Components/pages/Admin/Version.js"));
  const Overview1 = React.lazy(() => import("./Components/pages/Overview/Overview.js"));
  const Doctor = React.lazy(() => import("./Components/pages/Management/Docotor/Doctor.js"));
  const DoctorProfile = React.lazy(() => import("./Components/pages/Management/Docotor/DoctorProfile.js"));
  const Patient = React.lazy(() => import("./Components/pages/Management/Patient.js"));
  const Speciality = React.lazy(() => import("./Components/pages/Tools/Speciality/Speciality.js"));
  const Qualification = React.lazy(() => import("./Components/pages/Tools/Qulification/Qulification.js"));
  const StateMedicalCouncil = React.lazy(() => import("./Components/pages/Tools/StateCouncil/StateCouncil.js"));
  const Slots = React.lazy(() => import("./Components/pages/Slots/Slots.js"));
  const BookAppointment = React.lazy(() => import("./Components/pages/BookAppointment/BookAppointment.js"));
  const DoctorSlots = React.lazy(() => import("./Components/pages/Management/DoctorSlot/DoctorSlot.js"));
  const Transaction = React.lazy(() => import("./Components/pages/Management/Transaction/Transaction.js"));
  const Receptionist = React.lazy(() => import("./Components/pages/Management/Receptionist/Receptionist.js"));
  const CreateSlot = React.lazy(() => import("./Components/pages/Management/DoctorSlot/CreateSlot.js"));
  const Appointment = React.lazy(() => import("./Components/pages/Appointment/Appointment.js"));
  const PatientList = React.lazy(() => import("./Components/pages/Appointment/PatientList.js"));
  const Profile = React.lazy(() => import("./Components/pages/Management/Profile/Profile.js"));
  const ProfileSettings = React.lazy(() => import("./Components/pages/Management/Profile/ProfileSettings.js"));
  const Settings = React.lazy(() => import("./Components/pages/Management/Settings/Settings.js"));
  const Accountdeletion = React.lazy(() => import("./Components/pages/Account/Accountdeletion.js"));



  const DashBoard = (Component) => {
    return (
      <Layouts>
        <Component />

      </Layouts>
    );
  };


  const token = JSON.parse(localStorage.getItem("adminlogin"));

  // const token = true; //without login use 
  // const token = false;


  const Secure = (Component) => {
    if (!token) {
      return <Navigate to="/" />;
    }

    return DashBoard(Component);

  }

  const InSecure = (Component) => {
    if (token) {
      return <Navigate to="/Overview" />;
    }
    return <Component />;
  };

  const routes = [
    { path: "/Overview", element: Secure(Overview) },
    { path: "/docters", element: Secure(Doctor) },
    { path: "/slots", element: Secure(DoctorSlots) },
    { path: "/patients", element: Secure(Patient) },
    { path: "/notification", element: Secure(Notification) },
    // { path: "/chat", element: Secure(Chat) },
    { path: "/teams", element: Secure(Teams) },
    { path: "/", element: InSecure(Login) },
    // { path: "/login", element: InSecure(Login) },
    { path: "/signup", element: InSecure(SignUp) },
    { path: "/qualification", element: Secure(Qualification) },
    { path: "/version", element: Secure(Version) },
    { path: "/book-token", element: Secure(Slots) },
    { path: "/create-slot", element: Secure(CreateSlot) },
    { path: "/appointment", element: Secure(Appointment) },
    { path: "/appointment-patient-list", element: Secure(PatientList) },
    { path: "/book-appointment", element: Secure(BookAppointment) },
    { path: "/transaction", element: Secure(Transaction) },
    // { path: "/overview", element: Secure(Overview) },  
    { path: "/speciality", element: Secure(Speciality) },
    { path: "/medical-councils", element: Secure(StateMedicalCouncil) },
    { path: "/receptionist", element: Secure(Receptionist) },
    { path: "/doctor-profile", element: Secure(DoctorProfile) },
    { path: "/profile", element: Secure(Profile) },
    { path: "/profile-settings", element: Secure(ProfileSettings) },
    { path: "/settings", element: Secure(Settings) },
    { path: "/account-deletion", element:InSecure(Accountdeletion)},


  ];


  return (
    <HospitalProvider>
      <Router>
        <Suspense
          fallback={
            <div className="loader-wrapper">
              <div className="loader-card">
                <div className="logo"></div>
                <div className="dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="loading-text">Please wait...</div>
              </div>
            </div>
          }
        >
          <ToastContainer position="top-right" autoClose={3000} />
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Suspense>
      </Router>
    </HospitalProvider>
  );
}

export default App;

